// docs/41: the puzzle room's board and its panel share one thing — which fixture the party is
// looking at. A hint (a nudge or a step) lights the fixture it is about; a clue or a piece in the
// panel lights its fixture on hover. The board's fixture layer reads `focus` and glows it, and
// draws the room's workings only around the fixtures a bought hint named (`hinted`, PZ8).
import { create } from 'zustand';

interface PuzzleStore {
  /** The fixture the board should light (`FixtureId.0`), if any. */
  focus?: number;
  /** Where the focus came from: a hint stays lit, a hover clears when the pointer leaves. */
  source?: 'hint' | 'hover';
  setFocus(fixture: number | undefined, source?: 'hint' | 'hover'): void;
  /** The fixtures a bought Nudge or Step has pointed at, this room, and those a Step did. */
  hinted: ReadonlySet<number>;
  stepped: ReadonlySet<number>;
  setHinted(hinted: ReadonlySet<number>, stepped: ReadonlySet<number>): void;
}

export const usePuzzle = create<PuzzleStore>()((set, get) => ({
  hinted: new Set(),
  stepped: new Set(),
  setHinted(hinted, stepped) {
    const same = (a: ReadonlySet<number>, b: ReadonlySet<number>) => a.size === b.size && [...a].every((x) => b.has(x));
    const s = get();
    if (!same(hinted, s.hinted) || !same(stepped, s.stepped)) set({ hinted, stepped });
  },
  setFocus(focus, source = 'hover') { set(focus === undefined ? { focus: undefined, source: undefined } : { focus, source }); },
}));
